import actionCreatorFactory from 'typescript-fsa'

import { GetGooglePageRequest, GetGooglePageFeedRequest, DeletePostRequest } from '@3m5/sm_publish-frontend-api'
import { DeferredPost, GooglePage, GooglePost } from '@3m5/sm_publish-frontend-api/models'
import {
  ConfirmManualDeferredPostRequest,
  DeclineManualDeferredPostRequest,
  DeleteManualDeferredPostRequest,
  RetryManualDeferredPostRequest,
  UpdateDeferredPostRequest,
} from '@3m5/sm_publish-frontend-api/apis/DeferredPostApi'

const actionCreator = actionCreatorFactory('LOGIN')

/*
 * Actions
 */
export const getGooglePageInitiated = actionCreator<GetGooglePageRequest>('GET_GOOGLE_PAGE_INITIATED')
export const getGooglePage = actionCreator.async<GetGooglePageRequest, GooglePage>('GET_GOOGLE_PAGE')

export const getGooglePageFeedInitiated = actionCreator<GetGooglePageFeedRequest>('GET_GOOGLE_PAGE_FEED_INITIATED')
export const getGooglePageFeed = actionCreator.async<GetGooglePageFeedRequest, GooglePost[]>('GET_GOOGLE_PAGE_FEED')

export const deleteGooglePostInitiated = actionCreator<DeletePostRequest>('DELETE_GOOGLE_POST_INITIATED')
export const deleteGooglePost = actionCreator.async<DeletePostRequest, void>('DELETE_GOOGLE_POST')

// für DeferredPostSource.ManualAbo (> forceConfirm > alle anderen DeferredPosts)
export const confirmManualDeferredPostInitiated = actionCreator<ConfirmManualDeferredPostRequest>('CONFIRM_MANUAL_DEFERRED_POST_INITIATED')
export const confirmManualDeferredPost = actionCreator.async<ConfirmManualDeferredPostRequest, void>('CONFIRM_MANUAL_DEFERRED_POST')

// für DeferredPostSource.ManualAbo
export const declineManualDeferredPostInitiated = actionCreator<DeclineManualDeferredPostRequest>('DECLINE_MANUAL_DEFERRED_POST_INITIATED')
export const declineManualDeferredPost = actionCreator.async<DeclineManualDeferredPostRequest, void>('DECLINE_MANUAL_DEFERRED_POST')

// für alle anderen DeferredPosts
export const deleteManualDeferredPostInitiated = actionCreator<DeleteManualDeferredPostRequest>('DELETE_MANUAL_DEFERRED_POST_INITIATED')
export const deleteManualDeferredPost = actionCreator.async<DeleteManualDeferredPostRequest, void>('DELETE_MANUAL_DEFERRED_POST')

// für alle anderen DeferredPosts > Datum prüfen
export const retryManualDeferredPostInitiated = actionCreator<RetryManualDeferredPostRequest>('RETRY_MANUAL_DEFERRED_POST_INITIATED')
export const retryManualDeferredPost = actionCreator.async<RetryManualDeferredPostRequest, void>('RETRY_MANUAL_DEFERRED_POST')

export const updateDeferredPostInitiated = actionCreator<UpdateDeferredPostRequest>('UPDATE_DEFERRED_POST_INITIATED')
export const updateDeferredPost = actionCreator.async<UpdateDeferredPostRequest, DeferredPost>('UPDATE_DEFERRED_POST')
